import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { toast } from 'react-toastify';

const getScenarioApiUrl = 'http://drivee.localhost/api/fmodel/scenarios/';

const addScenarioApiUrl = 'http://drivee.localhost/api/fmodel/scenarios/';

const apiUrlTest = 'http://drivee.localhost/api/fmodel/diy/';

// TODO: move to utils and reuse
export const toastSuccessHelper = (msg) => {
  toast.success(msg, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    progress: 0
  });
};

const getScenariosApi = async () => {
  try {
    const {
      data: { data }
    } = await axios.get(getScenarioApiUrl);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const addScenarioApi = async (scenario) => {
  try {
    const {
      data: { data }
    } = await axios.post(addScenarioApiUrl, scenario);
    return data.output.outputs;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const getDataSourcesApi = async () => {
  try {
    const {
      data: { data }
    } = await axios.get(apiUrlTest);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

function* fetchScenarios(action) {
  try {
    const scenarios = yield call(getScenariosApi);
    yield put({ type: 'GET_SCENARIOS_SUCCESS', scenarios });
  } catch (error) {
    yield put({ type: 'GET_SCENARIOS_FAILED', error: error.message });
  }
}

function* addScenario(action) {
  try {
    const outputs = yield call(addScenarioApi, action.scenario);

    yield put({ type: 'ADD_SCENARIO_SUCCESS', outputs });
    toastSuccessHelper('Scenario successfully created');
  } catch (error) {
    yield put({ type: 'ADD_SCENARIO_FAILED', error: error.message });
  }
}

function* fetchDatasources(action) {
  try {
    const datasources = yield call(getDataSourcesApi);
    yield put({ type: 'GET_DATASOURCES_SUCCESS', datasources });
  } catch (error) {
    yield put({ type: 'GET_DATASOURCES_FAILED', error: error.message });
  }
}

function* watchScenariosSaga() {
  yield takeEvery('GET_SCENARIOS_REQUEST', fetchScenarios);
}

function* watchAddScenarioSaga() {
  yield takeEvery('ADD_SCENARIO_REQUEST', addScenario);
}

function* watchDatasourcesSaga() {
  yield takeEvery('GET_DATASOURCES_REQUEST', fetchDatasources);
}

export const scenariosSagas = {
  watchScenariosSaga,
  watchDatasourcesSaga,
  watchAddScenarioSaga
};
